import * as Yup from 'yup'

const cmsStoryGroupFormScheme = Yup.object().shape({
  title                  : Yup.string().required('Required'),
  thumbnail_cms_image_id : Yup.number().required('Required'),
  is_active              : Yup.bool().required('Required'),
  starts_at              : Yup.date().required('Required'),
  starts_time            : Yup.string(),

  expires_at: Yup.date()
    .min(
      Yup.ref('starts_at'),
      'Expired Date harus lebih besar dari Start Date'
    )
    .required('Required'),
  expires_time: Yup.string(),

  stories: Yup.array().of(
    Yup.object().shape({
      id            : Yup.number(),
      cms_media_id  : Yup.number().required('Required'),
      button_text   : Yup.string().nullable(),
      link_url_path : Yup.string().when('button_text', {
        is: (button_text) => {
          if (button_text === undefined)
            return false
          return button_text.length > 0
        },
        then: Yup.string().required('Required')
      })
    })
  )
})

export default cmsStoryGroupFormScheme
